import { useState } from 'react';
import Portal from '../../utils/Portal';
import styles from './style.module.css';

export default function ToolTip({children,className=null,message=null}){
    const [isShow,setIsShow]=useState(false);
    const [pos,setPos]=useState({x:0,y:0})
    const toolTipMsg = message ? message : children;

    const handleMouseEnter=()=>{
        setIsShow(true);
    }

    const handleMouseLeave=()=>{
        setIsShow(false);
    }

    const handleMouseMove=(e)=>{
        setPos({
            x:e.pageX,
            y:e.pageY,
        })
    }

    return(
        <>
        <div className={`${styles['wrap']} ${className}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}>
            {children}
        </div>
        {isShow&&(<Portal>
            <div className={styles['body']}
            style={{top:pos.y + 10,left:pos.x + 10}}>
            {toolTipMsg}
            </div>
        </Portal>)}
        </>
    )
}